import React, { useState } from 'react';
import { Box, Avatar } from '@mui/material';
import NotificationBell from './NotificationBell';

function getInitials(value) {
  return (value ?? '').trim().slice(0, 2).toUpperCase();
}

export default function UserActions() {
  const userEmail = sessionStorage.getItem('userEmail');
  const initials = getInitials(userEmail);
  const [notifAnchorEl, setNotifAnchorEl] = useState(null);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <NotificationBell
        anchorEl={notifAnchorEl}
        onOpen={(e) => setNotifAnchorEl(e.currentTarget)}
        onClose={() => setNotifAnchorEl(null)}
      />
      <Avatar
        sx={{
          width: 36,
          height: 36,
          fontSize: '0.85rem',
          fontWeight: 'bold',
          bgcolor: 'primary.main',
        }}
      >
        {initials}
      </Avatar>
    </Box>
  );
}
